module.exports = __webpack_public_path__ + "/images/logo-app-google.en-GB.1761514.svg";